import dayjs from 'dayjs';
import { DataGridIdentifiers } from '../components/Interface';
import { DocStatus } from '../config/document';
import { DocumentType } from '../config/DocumentType';
import { v4 as uuidv4 } from 'uuid';
import addNotification from './addNotification';
import { NotificationType } from '../config';
import { DocumentDirection } from '../config/DocumentDirection';

const PURCHASE_ORDER_EMPTY_HEADER_FIELDS = {
  companyId: null,
  companyName: null,
  companyCode: null,
  companyContactId: null,
  currencyCode: null,
  paymentMethodId: null,
  billingAdressId: null,
  billingCountry: null,
  billingProvince: null,
  billingPostCode: null,
  billingCity: null,
  billingStreetAddress: null,
  shippingAdressId: null,
  shippingCountry: null,
  shippingProvince: null,
  shippingPostCode: null,
  shippingCity: null,
  shippingStreetAddress: null,
  deliverymethodId: null,
  incotermCode: null,
  priceListId: null,
  langCode: null,
  hunTaxNumber: null,
  euTaxNumber: null,
  foreignTaxNumber: null,
  incotermCity: null,
  companyWarning: null,
  shortName: null,
};

const PURCHASE_ORDER_EMPTY_LINE_FIELDS = {
  unitPrice: null,
  vatCode: null,
  netPrice: null,
  grossPrice: null,
  grossUnitPrice: null,
  baseUnitPrice: null,
  baseGrossUnitPrice: null,
  vatValueInOwnCur: null,
  netPriceInOwnCur: null,
  grossPriceInOwnCur: null,
  vatValue: null,
  vatPercent: null,
};

export const getDocDataGridIdentifiers = (docTypeId) => {
  switch (parseInt(docTypeId)) {
    case DocumentType.SalesQuotation:
      return {
        doc: DataGridIdentifiers.SalesQuotationDoc,
        docLine: DataGridIdentifiers.SalesQuotationDocLine,
      };
    case DocumentType.CustomerOrder:
      return {
        doc: DataGridIdentifiers.CustomerOrderDoc,
        docLine: DataGridIdentifiers.CustomerOrderDocLine,
      };
    case DocumentType.Delivery:
      return {
        doc: DataGridIdentifiers.DeliveryNoteDoc,
        docLine: DataGridIdentifiers.DeliveryNoteDocLine,
      };
    case DocumentType.CompletionCertificate:
      return {
        doc: DataGridIdentifiers.CompletionCertificateDoc,
        docLine: DataGridIdentifiers.CompletionCertificateDocLine,
      };
    case DocumentType.Return:
      return {
        doc: DataGridIdentifiers.ReturnDoc,
        docLine: DataGridIdentifiers.ReturnDocLine,
      };
    case DocumentType.DownPaymentRequest:
      return {
        doc: DataGridIdentifiers.DownPaymentRequestDoc,
        docLine: DataGridIdentifiers.DownPaymentRequestDocLine,
      };
    case DocumentType.DownPayment:
      return {
        doc: DataGridIdentifiers.DownPaymentDoc,
        docLine: DataGridIdentifiers.DownPaymentDocLine,
      };
    case DocumentType.ARInvoice:
      return {
        doc: DataGridIdentifiers.ARInvoiceDoc,
        docLine: DataGridIdentifiers.ARInvoiceDocLine,
      };
    case DocumentType.PurchaseRequest:
      return {
        doc: DataGridIdentifiers.PurchaseRequestDoc,
        docLine: DataGridIdentifiers.PurchaseRequestDocLine,
      };
    case DocumentType.PurchaseQuotation:
      return {
        doc: DataGridIdentifiers.PurchaseQuotationDoc,
        docLine: DataGridIdentifiers.PurchaseQuotationDocLine,
      };
    case DocumentType.PurchaseOrder:
      return {
        doc: DataGridIdentifiers.PurchaseOrderDoc,
        docLine: DataGridIdentifiers.PurchaseOrderDocLine,
      };
    case DocumentType.PurchaseDelivery:
      return {
        doc: DataGridIdentifiers.PurchaseDeliveryNoteDoc,
        docLine: DataGridIdentifiers.PurchaseDeliveryNoteDocLine,
      };
    case DocumentType.GoodsReturn:
      return {
        doc: DataGridIdentifiers.GoodsReturnDoc,
        docLine: DataGridIdentifiers.GoodsReturnDocLine,
      };
    case DocumentType.APDownPaymentRequest:
      return {
        doc: DataGridIdentifiers.APDownPaymentRequestDoc,
        docLine: DataGridIdentifiers.APDownPaymentRequestDocLine,
      };
    case DocumentType.APDownPayment:
      return {
        doc: DataGridIdentifiers.APDownPaymentDoc,
        docLine: DataGridIdentifiers.APDownPaymentDocLine,
      };
    case DocumentType.APInvoice:
      return {
        doc: DataGridIdentifiers.APInvoiceDoc,
        docLine: DataGridIdentifiers.APInvoiceDocLine,
      };
    case DocumentType.PurchaseOrderVariant:
      return {
        doc: DataGridIdentifiers.PurchaseOrderVariantDoc,
        docLine: DataGridIdentifiers.PurchaseOrderVariantDocLine,
      };
    case DocumentType.InventoryTransfer:
      return {
        doc: DataGridIdentifiers.InventoryTransferDoc,
        docLine: DataGridIdentifiers.InventoryTransferDocLine,
      };
    case DocumentType.GoodsReceipt:
    case DocumentType.ConversionReceipt:
      return {
        doc: DataGridIdentifiers.GoodsReceiptDoc,
        docLine: DataGridIdentifiers.GoodsReceiptDocLine,
      };
    case DocumentType.GoodsIssue:
    case DocumentType.ConversionIssue:
      return {
        doc: DataGridIdentifiers.GoodsIssueDoc,
        docLine: DataGridIdentifiers.GoodsIssueDocLine,
      };
    case DocumentType.ProjectIssue:
      return {
        doc: DataGridIdentifiers.ProjectIssueDoc,
        docLine: DataGridIdentifiers.ProjectIssueDocLine,
      };
    case DocumentType.CooperationIssue:
      return {
        doc: DataGridIdentifiers.CooperationIssueDoc,
        docLine: DataGridIdentifiers.CooperationIssueDocLine,
      };
    case DocumentType.EmployeeIssue:
      return {
        doc: DataGridIdentifiers.EmployeeIssueDoc,
        docLine: DataGridIdentifiers.EmployeeIssueDocLine,
      };
    case DocumentType.InventoryCounting:
      return {
        doc: DataGridIdentifiers.InventoryCountingDoc,
        docLine: DataGridIdentifiers.InventoryCountingDocLine,
      };
    case DocumentType.InventoryCountingDif:
      return {
        doc: DataGridIdentifiers.InventoryCountingDifDoc,
        docLine: DataGridIdentifiers.InventoryCountingDifDocLine,
      };
    case DocumentType.ReceiptFromProduction:
      return {
        doc: DataGridIdentifiers.ReceiptFromProductionDoc,
        docLine: DataGridIdentifiers.ReceiptFromProductionDocLine,
      };
    case DocumentType.IssueForProduction:
      return {
        doc: DataGridIdentifiers.IssueForProductionDoc,
        docLine: DataGridIdentifiers.IssueForProductionDocLine,
      };
    case DocumentType.ProductionOrder:
      return {
        doc: DataGridIdentifiers.ProductionOrderDoc,
        docLine: DataGridIdentifiers.ProductionOrderDocLine,
      };
    case DocumentType.IssueForService:
      return {
        doc: DataGridIdentifiers.IssueForServiceDoc,
        docLine: DataGridIdentifiers.IssueForServiceDocLine,
      };
    case DocumentType.ReceiptFromService:
      return {
        doc: DataGridIdentifiers.ReceiptFromServiceDoc,
        docLine: DataGridIdentifiers.ReceiptFromServiceDocLine,
      };
    case DocumentType.ReturnFromProduction:
      return {
        doc: DataGridIdentifiers.ReturnFromProductionDoc,
        docLine: DataGridIdentifiers.ReturnFromProductionDocLine,
      };
    case DocumentType.ReturnFromIssue:
      return {
        doc: DataGridIdentifiers.ReturnFromIssueDoc,
        docLine: DataGridIdentifiers.ReturnFromIssueDocLine,
      };
    case DocumentType.ProjectReturn:
      return {
        doc: DataGridIdentifiers.ProjectReturnDoc,
        docLine: DataGridIdentifiers.ProjectReturnDocLine,
      };
    case DocumentType.CooperationReturn:
      return {
        doc: DataGridIdentifiers.CooperationReturnDoc,
        docLine: DataGridIdentifiers.CooperationReturnDocLine,
      };
    case DocumentType.EmployeeReturn:
      return {
        doc: DataGridIdentifiers.EmployeeReturnDoc,
        docLine: DataGridIdentifiers.EmployeeReturnDocLine,
      };
    default:
      return DataGridIdentifiers.documentReports;
  }
};

export const getSourceDocDataGridIdentifiers = (docTypeId) => {
  switch (parseInt(docTypeId)) {
    case DocumentType.SalesQuotation:
      return {
        sourceDoc: DataGridIdentifiers.SourceSalesQuotationDoc,
        sourceDocLine: DataGridIdentifiers.SourceSalesQuotationDocLine,
      };
    case DocumentType.CustomerOrder:
      return {
        sourceDoc: DataGridIdentifiers.SourceCustomerOrderDoc,
        sourceDocLine: DataGridIdentifiers.SourceCustomerOrderDocLine,
      };
    case DocumentType.Delivery:
      return {
        sourceDoc: DataGridIdentifiers.SourceDeliveryNoteDoc,
        sourceDocLine: DataGridIdentifiers.SourceDeliveryNoteDocLine,
      };
    case DocumentType.Return:
      return {
        sourceDoc: DataGridIdentifiers.SourceReturnDoc,
        sourceDocLine: DataGridIdentifiers.SourceReturnDocLine,
      };
    case DocumentType.DownPaymentRequest:
      return {
        sourceDoc: DataGridIdentifiers.SourceDownPaymentRequestDoc,
        sourceDocLine: DataGridIdentifiers.SourceDownPaymentRequestDocLine,
      };
    case DocumentType.DownPayment:
      return {
        sourceDoc: DataGridIdentifiers.SourceDownPaymentDoc,
        sourceDocLine: DataGridIdentifiers.SourceDownPaymentDocLine,
      };
    case DocumentType.ARInvoice:
      return {
        sourceDoc: DataGridIdentifiers.SourceARInvoiceDoc,
        sourceDocLine: DataGridIdentifiers.SourceARInvoiceDocLine,
      };
    case DocumentType.PurchaseRequest:
      return {
        sourceDoc: DataGridIdentifiers.SourcePurchaseRequestDoc,
        sourceDocLine: DataGridIdentifiers.SourcePurchaseRequestDocLine,
      };
    case DocumentType.PurchaseQuotation:
      return {
        sourceDoc: DataGridIdentifiers.SourcePurchaseQuotationDoc,
        sourceDocLine: DataGridIdentifiers.SourcePurchaseQuotationDocLine,
      };
    case DocumentType.PurchaseOrder:
      return {
        sourceDoc: DataGridIdentifiers.SourcePurchaseOrderDoc,
        sourceDocLine: DataGridIdentifiers.SourcePurchaseOrderDocLine,
      };
    case DocumentType.PurchaseDelivery:
      return {
        sourceDoc: DataGridIdentifiers.SourcePurchaseDeliveryNoteDoc,
        sourceDocLine: DataGridIdentifiers.SourcePurchaseDeliveryNoteDocLine,
      };
    case DocumentType.GoodsReturn:
      return {
        sourceDoc: DataGridIdentifiers.SourceGoodsReturnDoc,
        sourceDocLine: DataGridIdentifiers.SourceGoodsReturnDocLine,
      };
    case DocumentType.APDownPaymentRequest:
      return {
        sourceDoc: DataGridIdentifiers.SourceAPDownPaymentRequestDoc,
        sourceDocLine: DataGridIdentifiers.SourceAPDownPaymentRequestDocLine,
      };
    case DocumentType.APDownPayment:
      return {
        sourceDoc: DataGridIdentifiers.SourceAPDownPaymentDoc,
        sourceDocLine: DataGridIdentifiers.SourceAPDownPaymentDocLine,
      };
    case DocumentType.APInvoice:
      return {
        sourceDoc: DataGridIdentifiers.SourceAPInvoiceDoc,
        sourceDocLine: DataGridIdentifiers.SourceAPInvoiceDocLine,
      };
    case DocumentType.PurchaseOrderVariant:
      return {
        sourceDoc: DataGridIdentifiers.SourcePurchaseOrderVariantDoc,
        sourceDocLine: DataGridIdentifiers.SourcePurchaseOrderVariantDocLine,
      };
    case DocumentType.InventoryTransfer:
      return {
        sourceDoc: DataGridIdentifiers.SourceInventoryTransferDoc,
        sourceDocLine: DataGridIdentifiers.SourceInventoryTransferDocLine,
      };
    case DocumentType.GoodsReceipt:
    case DocumentType.ConversionReceipt:
      return {
        sourceDoc: DataGridIdentifiers.SourceGoodsReceiptDoc,
        sourceDocLine: DataGridIdentifiers.SourceGoodsReceiptDocLine,
      };
    case DocumentType.GoodsIssue:
    case DocumentType.ConversionIssue:
      return {
        sourceDoc: DataGridIdentifiers.SourceGoodsIssueDoc,
        sourceDocLine: DataGridIdentifiers.SourceGoodsIssueDocLine,
      };
    case DocumentType.ProjectIssue:
      return {
        sourceDoc: DataGridIdentifiers.SourceProjectIssueDoc,
        sourceDocLine: DataGridIdentifiers.SourceProjectIssueDocLine,
      };
    case DocumentType.CooperationIssue:
      return {
        sourceDoc: DataGridIdentifiers.SourceCooperationIssueDoc,
        sourceDocLine: DataGridIdentifiers.SourceCooperationIssueDocLine,
      };
    case DocumentType.EmployeeIssue:
      return {
        sourceDoc: DataGridIdentifiers.SourceEmployeeIssueDoc,
        sourceDocLine: DataGridIdentifiers.SourceEmployeeIssueDocLine,
      };
    case DocumentType.InventoryCounting:
      return {
        sourceDoc: DataGridIdentifiers.SourceInventoryCountingDoc,
        sourceDocLine: DataGridIdentifiers.SourceInventoryCountingDocLine,
      };
    case DocumentType.InventoryCountingDif:
      return {
        sourceDoc: DataGridIdentifiers.SourceInventoryCountingDifDoc,
        sourceDocLine: DataGridIdentifiers.SourceInventoryCountingDifDocLine,
      };
    case DocumentType.ReceiptFromProduction:
      return {
        sourceDoc: DataGridIdentifiers.SourceReceiptFromProductionDoc,
        sourceDocLine: DataGridIdentifiers.SourceReceiptFromProductionDocLine,
      };
    case DocumentType.IssueForProduction:
      return {
        sourceDoc: DataGridIdentifiers.SourceIssueForProductionDoc,
        sourceDocLine: DataGridIdentifiers.SourceIssueForProductionDocLine,
      };
    case DocumentType.ProductionOrder:
      return {
        sourceDoc: DataGridIdentifiers.SourceProductionOrderDoc,
        sourceDocLine: DataGridIdentifiers.SourceProductionOrderDocLine,
      };
    case DocumentType.IssueForService:
      return {
        sourceDoc: DataGridIdentifiers.SourceIssueForServiceDoc,
        sourceDocLine: DataGridIdentifiers.SourceIssueForServiceDocLine,
      };
    case DocumentType.ReceiptFromService:
      return {
        sourceDoc: DataGridIdentifiers.SourceReceiptFromServiceDoc,
        sourceDocLine: DataGridIdentifiers.SourceReceiptFromServiceDocLine,
      };
    case DocumentType.ReturnFromProduction:
      return {
        sourceDoc: DataGridIdentifiers.SourceReturnFromProductionDoc,
        sourceDocLine: DataGridIdentifiers.SourceReturnFromProductionDocLine,
      };
    case DocumentType.ReturnFromIssue:
      return {
        sourceDoc: DataGridIdentifiers.SourceReturnFromIssueDoc,
        sourceDocLine: DataGridIdentifiers.SourceReturnFromIssueDocLine,
      };
    case DocumentType.ProjectReturn:
      return {
        sourceDoc: DataGridIdentifiers.SourceProjectReturnDoc,
        sourceDocLine: DataGridIdentifiers.SourceProjectReturnDocLine,
      };
    case DocumentType.CooperationReturn:
      return {
        sourceDoc: DataGridIdentifiers.SourceCooperationReturnDoc,
        sourceDocLine: DataGridIdentifiers.SourceCooperationReturnDocLine,
      };
    case DocumentType.EmployeeReturn:
      return {
        sourceDoc: DataGridIdentifiers.SourceEmployeeReturnDoc,
        sourceDocLine: DataGridIdentifiers.SourceEmployeeReturnDocLine,
      };
    default:
      return DataGridIdentifiers.documentReports;
  }
};

export const getDocumentTypeKeyUpperCase = (value) => {
  return Object.entries(DocumentType)
    .find(([_, v]) => v === parseInt(value))?.[0]
    ?.toUpperCase();
};

export const extractCopyPayload = (
  selectedValues,
  newDocType = null,
  defVals = {},
  docName = '',
  currDocTypeId = null,
  { includeClosedLinesForStorno = false, includeClosedLinesForReturn = false, useSelectedDocumentAsBase = false } = {}
) => {
  const nowIso = dayjs().toISOString();
  const resolvedCompanyCode = selectedValues?.companyCode ?? selectedValues?.company?.code ?? '';
  const resolvedCompanyName = selectedValues?.companyName ?? selectedValues?.company?.name ?? '';

  const shouldClearPurchaseOrderFields =
    (parseInt(newDocType) === DocumentType.PurchaseOrder ||
      parseInt(newDocType) === DocumentType.PurchaseOrderVariant) &&
    parseInt(currDocTypeId) === DocumentType.CustomerOrder;

  const baseHeader = {
    ...selectedValues,
    docNum: '',
    customStatus: null,
    customDocStatus: null,
    docDate: newDocType ? nowIso : selectedValues.docDate,
    issueDate: nowIso,
    dueDate: newDocType ? nowIso : selectedValues.dueDate,
    docStatus: newDocType ? DocStatus.OPENED : DocStatus.CANCELLATION,
    docTypeId: newDocType ?? selectedValues.docTypeId,
    mode: 'copy',
    note: `Forrása: ${docName} ${selectedValues.docNum}`,
    balanceSettled: false,
    settledAmount: null,
    openAmount: null,
    companyCode: resolvedCompanyCode,
    companyName: resolvedCompanyName,
    settlement: [],
    appliedGrossAmount: 0,

    ...(shouldClearPurchaseOrderFields && PURCHASE_ORDER_EMPTY_HEADER_FIELDS),
  };
  delete baseHeader.supportingDocumentAssignment;

  if ([DocumentType.DownPaymentRequest, DocumentType.APDownPaymentRequest].includes(parseInt(newDocType))) {
    if (!defVals.itemCode) {
      addNotification({
        content: 'Hiányzik az alapértelmezett cikk kódja!',
        type: NotificationType.ERROR,
      });
      return;
    }

    const toAmount = (value) => {
      const amount = Number(value);
      return Number.isFinite(amount) ? amount : 0;
    };
    const sourceLines = selectedValues?.docLine ?? [];
    const linesByVatCode = sourceLines.reduce((groups, line) => {
      const vatCode = line?.vatCode ?? defVals?.vatCode ?? null;
      const groupKey = vatCode ?? '';
      const current = groups.get(groupKey) ?? {
        vatCode,
        vatPercent: line?.vatPercent ?? defVals?.vatPercent ?? null,
        netPrice: 0,
        vatValue: 0,
        grossPrice: 0,
        netPriceInOwnCur: 0,
        vatValueInOwnCur: 0,
        grossPriceInOwnCur: 0,
      };

      current.netPrice += toAmount(line?.netPrice);
      current.vatValue += toAmount(line?.vatValue);
      current.grossPrice += toAmount(line?.grossPrice);
      current.netPriceInOwnCur += toAmount(line?.netPriceInOwnCur);
      current.vatValueInOwnCur += toAmount(line?.vatValueInOwnCur);
      current.grossPriceInOwnCur += toAmount(line?.grossPriceInOwnCur);
      groups.set(groupKey, current);
      return groups;
    }, new Map());

    if (linesByVatCode.size === 0) {
      const netPrice = toAmount(selectedValues?.netInDocCur);
      const vatValue = toAmount(selectedValues?.VATInDocCur);
      const grossPrice = toAmount(selectedValues?.sumInDocCur);
      linesByVatCode.set(defVals?.vatCode ?? '', {
        vatCode: defVals?.vatCode ?? null,
        vatPercent: defVals?.vatPercent ?? null,
        netPrice,
        vatValue,
        grossPrice,
        netPriceInOwnCur: toAmount(selectedValues?.netInOwnCur),
        vatValueInOwnCur: toAmount(selectedValues?.VATInOwnCur),
        grossPriceInOwnCur: toAmount(selectedValues?.sumInOwnCur),
      });
    }

    const downPaymentLines = Array.from(linesByVatCode.values()).map((amounts, index) => ({
      ...defVals,
      id: uuidv4(),
      isNew: true,
      visOrder: index + 1,
      qty: 1,
      opnQty: 1,
      cplQty: 0,
      currencyCode: selectedValues?.currencyCode ?? defVals?.currencyCode,
      unitPrice: amounts.netPrice,
      grossUnitPrice: amounts.grossPrice,
      baseUnitPrice: amounts.netPrice,
      baseGrossUnitPrice: amounts.grossPrice,
      vatPercent: amounts.vatPercent,
      vatCode: amounts.vatCode,
      netPrice: amounts.netPrice,
      vatValue: amounts.vatValue,
      grossPrice: amounts.grossPrice,
      netPriceInOwnCur: amounts.netPriceInOwnCur,
      vatValueInOwnCur: amounts.vatValueInOwnCur,
      grossPriceInOwnCur: amounts.grossPriceInOwnCur,
      appliedGrossAmount: 0,
      baseId: selectedValues.docId,
      baseDocnum: selectedValues.docNum,
      baseDocType: selectedValues.docTypeId,
      baseLine: null,
      dueDate: nowIso,
    }));

    return {
      ...baseHeader,
      docLine: downPaymentLines,
    };
  }

  const docLine = (selectedValues?.docLine || [])
    .filter((line) =>
      includeClosedLinesForStorno || (includeClosedLinesForReturn && line?.lineStatus === DocStatus.CLOSED)
        ? line?.lineStatus === DocStatus.CLOSED && Number(line?.qty ?? 0) > 0
        : line?.lineStatus === DocStatus.OPENED && line?.opnQty > 0
    )
    .map((line) => ({
      ...line,
      id: uuidv4(),
      isNew: true,
      baseId: useSelectedDocumentAsBase ? selectedValues.docId : line.baseId ?? selectedValues.docId,
      baseDocnum: useSelectedDocumentAsBase ? selectedValues.docNum : line.baseDocnum ?? selectedValues.docNum,
      baseDocType: useSelectedDocumentAsBase ? selectedValues.docTypeId : line.baseDocType ?? selectedValues.docTypeId,
      baseLine: newDocType ? line.lineNum : line.baseLine,
      qty:
        includeClosedLinesForStorno || (includeClosedLinesForReturn && line.lineStatus === DocStatus.CLOSED)
          ? line.qty
          : line.opnQty,
      opnQty: 0,
      cplQty: 0,
      appliedGrossAmount: 0,
      dueDate: nowIso,
      lineStatus: newDocType
        ? includeClosedLinesForReturn
          ? DocStatus.OPENED
          : line.lineStatus
        : DocStatus.CANCELLATION,

      ...(shouldClearPurchaseOrderFields && PURCHASE_ORDER_EMPTY_LINE_FIELDS),
    }));

  const selectedItemCodes = new Set(docLine.map((line) => line.itemCode).filter(Boolean));

  return {
    ...baseHeader,
    ...(Array.isArray(selectedValues?.supportingDocumentAssignment)
      ? {
          supportingDocumentAssignment: selectedValues.supportingDocumentAssignment.filter((assignment) =>
            selectedItemCodes.has(assignment.itemCode)
          ),
        }
      : {}),
    docLine,
  };
};

export const isCellEditable = ({ currentDocType, selectedValues }) => {
  return ({ field, row }) => {
    if (
      field === 'vatCode' &&
      [DocumentType.DownPayment, DocumentType.APDownPayment].includes(Number(row?.baseDocType))
    )
      return false;
    if (selectedValues.docStatus === DocStatus.PLANNED) return true;
    if (field === 'itemName' && !currentDocType?.editableItemName) return false;
    if (field === 'whsCode' && currentDocType?.inventoryAccounting && !row?.isNew) return false;
    if (field === 'qty' && currentDocType.inventoryAccounting && !row?.isNew && selectedValues.mode !== 'copy')
      return false;
    if (field === 'itemCode' && !row?.isNew) return false;
    if (field === 'netPrice' && currentDocType?.direction !== DocumentDirection.INCOMING) {
      return false;
    }
    if (field === 'toWhsCode' && currentDocType?.direction !== DocumentDirection.INTERNAL) return false;
    if (field === 'toBinId' && currentDocType?.direction !== DocumentDirection.INTERNAL) return false;

    return true;
  };
};

export const getLineEditableFields = (apiRef, rowId, { currentDocType, selectedValues }) => {
  const allCols = apiRef.current.getVisibleColumns?.() ?? [];
  const row = apiRef.current.getRow?.(rowId);
  const canEdit = isCellEditable({ currentDocType, selectedValues });

  const editableFields = allCols
    .filter((c) => c.type !== 'actions' && c.editable)
    .filter((c) => {
      return canEdit({ field: c.field, row });
    })
    .map((c) => c.field);

  return editableFields;
};
